/**
 * Times read in local time (the default) or UTC, one choice for the whole app
 * (the audit log, an idea's research history). A per-browser convenience kept
 * in localStorage; a browser that refuses storage starts on local time each
 * visit.
 */

import { useState } from 'react';

// The audit log's key from before the choice was shared, so it carries over.
const STORAGE_KEY = 'wynxx.audit.timezone';

export function useTimeZone(): [boolean, (utc: boolean) => void] {
  const [utc, setUtc] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'utc';
    } catch {
      return false;
    }
  });
  function choose(next: boolean) {
    setUtc(next);
    try {
      localStorage.setItem(STORAGE_KEY, next ? 'utc' : 'local');
    } catch {
      // Not remembered; the choice still holds for this visit.
    }
  }
  return [utc, choose];
}
